<template>
  <div class="app-shell">

    <!-- ── Mobile overlay ── -->
    <div
        class="sidebar-overlay"
        :class="{ active: sidebarOpen }"
        @click="sidebarOpen = false"
    ></div>

    <!-- ══════════════ SIDEBAR ══════════════ -->
    <aside class="sidebar" :class="{ 'sidebar--open': sidebarOpen }">

      <div class="sidebar-logo">
        <div class="sidebar-logo-icon"><i class="fa fa-star"></i></div>
        <div class="sidebar-logo-texts">
          <div class="sidebar-logo-text">Dream Days</div>
          <div class="sidebar-logo-sub">Admin Panel</div>
        </div>
        <button class="sidebar-close" @click="sidebarOpen = false">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="sidebar-body">

        <router-link to="/" class="nav-item" exact>
          <i class="fa fa-home"></i> Dashboard
        </router-link>

        <div class="nav-section">Orders &amp; Sales</div>
        <router-link to="/orders"        class="nav-item"><i class="fa fa-list-alt"></i> Booked List</router-link>
        <router-link to="/b2b-orders"    class="nav-item"><i class="fa fa-building"></i> B2B Cart List</router-link>
        <router-link to="/gifts"         class="nav-item"><i class="fa fa-gift"></i> Gift List</router-link>
        <router-link to="/carts"         class="nav-item"><i class="fa fa-shopping-cart"></i> Carts List</router-link>
        <router-link to="/invoices"      class="nav-item"><i class="fa fa-file-text"></i> Invoices</router-link>
        <router-link to="/transactions"  class="nav-item"><i class="fa fa-exchange"></i> Transactions</router-link>

        <div class="nav-section">Customers</div>
        <router-link to="/users" class="nav-item"><i class="fa fa-users"></i> Customers List</router-link>

        <div class="nav-item nav-toggle" @click="toggle('corp')" v-b-toggle="'menu-corp'">
          <i class="fa fa-briefcase"></i>
          <span>Corporate</span>
          <b-badge pill variant="danger" v-if="corporateMessagesCount" class="nav-badge">
            {{ corporateMessagesCount }}
          </b-badge>
          <i class="fa fa-angle-down nav-caret" :class="{ 'fa-angle-up': open.corp }"></i>
        </div>
        <b-collapse id="menu-corp" class="nav-sub">
          <router-link to="/corporate-quote-list" class="nav-item">
            <i class="fa fa-reply"></i> Quote List
            <b-badge pill variant="danger" v-if="corporateMessagesCount" class="nav-badge">
              {{ corporateMessagesCount }}
            </b-badge>
          </router-link>
          <router-link to="/corporates" class="nav-item"><i class="fa fa-building-o"></i> Corporates</router-link>
        </b-collapse>

        <div class="nav-section">Experiences</div>
        <div class="nav-item nav-toggle" @click="toggle('exp')" v-b-toggle="'menu-exp'">
          <i class="fa fa-compass"></i>
          <span>Experiences</span>
          <i class="fa fa-angle-down nav-caret" :class="{ 'fa-angle-up': open.exp }"></i>
        </div>
        <b-collapse id="menu-exp" class="nav-sub">
          <router-link to="/experiences"    class="nav-item"><i class="fa fa-list"></i> Experience List</router-link>
          <router-link to="/collections"    class="nav-item"><i class="fa fa-clone"></i> Collections</router-link>
          <router-link to="/tags"           class="nav-item"><i class="fa fa-tag"></i> Tags</router-link>
          <router-link to="/cities"         class="nav-item"><i class="fa fa-map-marker"></i> Cities</router-link>
          <router-link to="/blackout-dates" class="nav-item"><i class="fa fa-calendar-times-o"></i> Blackout Dates</router-link>
        </b-collapse>

        <div class="nav-section">Content &amp; Marketing</div>
        <router-link to="/campaigns" class="nav-item">
          <i class="fa fa-bullhorn"></i> Campaigns
        </router-link>
        <router-link to="/promotions"      class="nav-item"><i class="fa fa-percent"></i> Promotions</router-link>
        <router-link to="/banners"         class="nav-item"><i class="fa fa-image"></i> Banners</router-link>
        <router-link to="/landing-pages"   class="nav-item"><i class="fa fa-desktop"></i> Landing Pages</router-link>
        <router-link to="/reviews"         class="nav-item"><i class="fa fa-star-o"></i> Reviews</router-link>
        <router-link to="/recommendations" class="nav-item"><i class="fa fa-heart-o"></i> Recommendations</router-link>

        <div class="nav-section">Analytics &amp; SEO</div>
        <div class="nav-item nav-toggle" @click="toggle('rep')" v-b-toggle="'menu-rep'">
          <i class="fa fa-bar-chart"></i>
          <span>Reports</span>
          <i class="fa fa-angle-down nav-caret" :class="{ 'fa-angle-up': open.rep }"></i>
        </div>
        <b-collapse id="menu-rep" class="nav-sub">
          <router-link to="/reports/supplier" class="nav-item"><i class="fa fa-truck"></i> Suppliers</router-link>
          <router-link to="/reports/product"  class="nav-item"><i class="fa fa-cube"></i> Product</router-link>
        </b-collapse>

        <router-link to="/searches" class="nav-item"><i class="fa fa-search"></i> Site Searches</router-link>

        <div class="nav-item nav-toggle" @click="toggle('seo')" v-b-toggle="'menu-seo'">
          <i class="fa fa-cog"></i>
          <span>SEO Settings</span>
          <i class="fa fa-angle-down nav-caret" :class="{ 'fa-angle-up': open.seo }"></i>
        </div>
        <b-collapse id="menu-seo" class="nav-sub">
          <router-link to="/redirects" class="nav-item"><i class="fa fa-random"></i> Redirects</router-link>
          <router-link to="/meta-data" class="nav-item"><i class="fa fa-code"></i> Meta Data</router-link>
        </b-collapse>

        <router-link to="/company-info" class="nav-item"><i class="fa fa-info-circle"></i> Company Info</router-link>
        <router-link to="/categories"   class="nav-item"><i class="fa fa-th-large"></i> Categories</router-link>

      </div>
    </aside>
    <!-- ══════════════ END SIDEBAR ══════════════ -->


    <!-- ══════════════ MAIN ══════════════ -->
    <div class="main" v-if="loaded">

      <!-- Header -->
      <header class="topbar">
        <button class="hamburger" @click="sidebarOpen = true">
          <i class="fa fa-bars"></i>
        </button>

        <div class="breadcrumb-area">
          <b-breadcrumb :items="$route.matched[0] && $route.matched[0].meta.breadcrumb"></b-breadcrumb>
        </div>

        <div class="topbar-actions">

          <!-- Messages -->
          <div style="position: relative;">
            <div class="hbtn" @click="msgOpen = !msgOpen">
              <i class="fa fa-envelope"></i>
              <span class="hbtn-dot" v-if="bootData.messages && bootData.messages.length"></span>
            </div>
            <div class="msg-dropdown" v-if="msgOpen && bootData.messages && bootData.messages.length">
              <div class="msg-header">Messages ({{ bootData.messages.length }})</div>
              <div
                  class="msg-item"
                  v-for="m in bootData.messages"
                  :key="m.id"
              >
                <span class="msg-tag">
                  {{ m.form_title === 'corporate quote list' ? 'Corporate' : m.form_title }}
                </span>
                <div class="msg-date">{{ formatDate(m.created_at) }}</div>
              </div>
            </div>
          </div>

          <!-- Theme toggle -->
          <div class="theme-btn" @click="isLight = !isLight">
            <i :class="isLight ? 'fa fa-moon-o' : 'fa fa-sun-o'"></i>
            <span class="theme-btn-label">{{ isLight ? 'Dark' : 'Light' }}</span>
          </div>

          <!-- User dropdown -->
          <b-dropdown variant="none" no-caret right class="user-dropdown">
            <template #button-content>
              <div class="user-pill">
                <div class="user-avatar">{{ userInitial }}</div>
                <span class="user-name">{{ userName }}</span>
                <i class="fa fa-angle-down" style="font-size: 11px; color: var(--text-3);"></i>
              </div>
            </template>
            <b-dropdown-item>
              <i class="fa fa-credit-card mr-1"></i>
              {{ bootData.user.balance }} AED
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="logout">
              <i class="fa fa-sign-out mr-1"></i> Log out
            </b-dropdown-item>
          </b-dropdown>

        </div>
      </header>

      <!-- Page content -->
      <div class="page-content">
        <router-view />
      </div>

    </div>
    <!-- ══════════════ END MAIN ══════════════ -->


    <!-- Loading screen -->
    <div class="loading-screen" v-if="!loaded">
      <div class="loading-logo"></div>
    </div>

  </div>
</template>


<script>
import { config } from "../helpers";

export default {
  data: () => ({
    bootData: null,
    loaded: false,
    isLight: true,        // پیش‌فرض: لایت
    msgOpen: false,
    sidebarOpen: false,
    open: { corp: false, exp: false, rep: false, seo: false },
    form: { password: "", confirm_password: "" },
  }),

  mounted() {
    const saved = localStorage.getItem("dd-theme") || "light";
    this.isLight = saved === "light";
    this.applyTheme(this.isLight);
    this.loadBootData();

    // بستن msg dropdown با کلیک بیرون
    document.addEventListener("click", this.closeMsgOnOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.closeMsgOnOutside);
  },

  watch: {
    "$route"() {
      this.sidebarOpen = false;   // بستن sidebar موبایل با navigation
      this.msgOpen = false;
    },
    isLight(val) {
      localStorage.setItem("dd-theme", val ? "light" : "dark");
      this.applyTheme(val);
    },
  },

  methods: {
    loadBootData() {
      axios.get(`${config("BACKEND_ROOT")}/admin/boot`).then((r) => {
        this.bootData = r.data;
        this.loaded = true;
      });
    },

    applyTheme(isLight) {
      const el = document.documentElement;
      if (isLight) {
        el.classList.add("theme-light");
        el.classList.remove("theme-dark");
      } else {
        el.classList.add("theme-dark");
        el.classList.remove("theme-light");
      }
    },

    toggle(key) {
      this.open[key] = !this.open[key];
    },

    closeMsgOnOutside(e) {
      if (!e.target.closest(".hbtn")) {
        this.msgOpen = false;
      }
    },

    logout() {
      if (!confirm("Are you sure?")) return;
      const tokenId = $cookies.get("dd-refresh-token").split("|", 1);
      axios.post(`${config("BACKEND_ROOT")}/auth/logout/${tokenId}`).then(() => {
        $cookies.remove("dd-access-token");
        $cookies.remove("dd-refresh-token");
        this.$router.push("/login");
      });
    },

    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${String(d.getMinutes()).padStart(2, "0")}`;
    },
  },

  computed: {
    corporateMessagesCount() {
      if (!this.bootData?.messages) return 0;
      return this.bootData.messages.filter(
          (m) => m.form_title === "corporate quote list"
      ).length;
    },
    userName() {
      const u = this.bootData?.user;
      if (!u) return "";
      return "Hello, " + (u.first_name || u.email?.split("@")[0]) + "!";
    },
    userInitial() {
      const u = this.bootData?.user;
      if (!u) return "A";
      return (u.first_name || u.email || "A")[0].toUpperCase();
    },
  },
};
</script>


<style >
/* ══════════════════════════════════════
   CSS Variables
   ══════════════════════════════════════ */

:root,
html.theme-light {
  --bg-base:    #f4f4f6;
  --bg-panel:   #ffffff;
  --bg-hover:   #f0f0f4;
  --border:     #e5e5e8;
  --border-2:   #d0d0d4;
  --text-1:     #111111;
  --text-2:     #555555;
  --text-3:     #999999;
  --accent:     #f42f4b;
  --sidebar-w:  220px;
}

html.theme-dark {
  --bg-base:    #0a0a0f;
  --bg-panel:   #111115;
  --bg-hover:   #1a1a1e;
  --border:     #1e1e1e;
  --border-2:   #2a2a2a;
  --text-1:     #ffffff;
  --text-2:     #aaaaaa;
  --text-3:     #555555;
  --accent:     #f42f4b;
  --sidebar-w:  220px;
}

/* Smooth theme transition */
*, *::before, *::after {
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', sans-serif;
  background: var(--bg-base);
  color: var(--text-1);
}

/* ══════════════════════════════════════
   APP SHELL
   ══════════════════════════════════════ */
.app-shell {
  display: flex;
  min-height: 100vh;
  background: var(--bg-base);
}

/* ══════════════════════════════════════
   SIDEBAR
   ══════════════════════════════════════ */
.sidebar {
  width: var(--sidebar-w);
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--bg-panel);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 200;
  transition: transform 0.25s ease, background 0.2s;
}

.sidebar-logo {
  height: 56px;
  background: var(--accent);
  display: flex;
  align-items: center;
  padding: 0 1rem;
  gap: 10px;
  flex-shrink: 0;
}

.sidebar-logo-icon {
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.sidebar-logo-texts { flex: 1; min-width: 0; }
.sidebar-logo-text  { color: #fff; font-size: 14px; font-weight: 500; }
.sidebar-logo-sub   { color: rgba(255, 255, 255, 0.6); font-size: 11px; }

.sidebar-close {
  display: none;          /* فقط موبایل */
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  color: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.sidebar-body {
  flex: 1;
  overflow-y: auto;
  padding: 0.75rem 0;
  scrollbar-width: thin;
  scrollbar-color: var(--border-2) transparent;
}
.sidebar-body::-webkit-scrollbar       { width: 3px; }
.sidebar-body::-webkit-scrollbar-thumb { background: var(--border-2); border-radius: 2px; }

/* Nav items */
.nav-section {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-3);
  letter-spacing: 0.7px;
  text-transform: uppercase;
  padding: 0 1rem;
  margin: 1rem 0 0.35rem;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 1rem;
  font-size: 12.5px;
  color: var(--text-2) !important;
  cursor: pointer;
  text-decoration: none !important;
  position: relative;
  transition: background 0.15s, color 0.15s;
}

.nav-item:hover {
  background: var(--bg-hover);
  color: var(--text-1) !important;
}

.nav-item.router-link-exact-active {
  color: var(--accent) !important;
  background: rgba(244, 47, 75, 0.08);
}

.nav-item.router-link-exact-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--accent);
  border-radius: 0 2px 2px 0;
}

.nav-item i:first-child {
  font-size: 14px;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
}

.nav-toggle { cursor: pointer; }
.nav-caret  { margin-left: auto !important; font-size: 12px !important; color: var(--text-3) !important; transition: transform 0.2s; }
.nav-badge  { margin-left: auto; }

.nav-sub .nav-item {
  padding: 6px 1rem 6px 2.75rem;
  font-size: 12px;
}

/* ══════════════════════════════════════
   MAIN
   ══════════════════════════════════════ */
.main {
  flex: 1;
  margin-left: var(--sidebar-w);   /* ← KEY FIX */
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 0;
}

/* ══════════════════════════════════════
   TOPBAR
   ══════════════════════════════════════ */
.topbar {
  height: 56px;
  background: var(--bg-panel);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.breadcrumb-area { flex: 1; min-width: 0; }
.breadcrumb-area .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 12px;
  color: var(--text-3);
}
.breadcrumb-area .breadcrumb-item + .breadcrumb-item::before { color: var(--text-3); }
.breadcrumb-area .breadcrumb-item.active { color: var(--text-1); }

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Hamburger — hidden on desktop */
.hamburger {
  display: none;
  width: 36px;
  height: 36px;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-2);
  font-size: 16px;
  flex-shrink: 0;
  transition: border-color 0.15s;
}
.hamburger:hover { border-color: var(--accent); color: var(--accent); }

/* Header icon button */
.hbtn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-2);
  font-size: 15px;
  position: relative;
  transition: border-color 0.15s, color 0.15s;
}
.hbtn:hover { border-color: var(--border-2); color: var(--text-1); }

.hbtn-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 7px;
  height: 7px;
  background: var(--accent);
  border-radius: 50%;
}

/* Messages dropdown */
.msg-dropdown {
  position: absolute;
  top: 42px;
  right: 0;
  width: 280px;
  background: var(--bg-panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  z-index: 999;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.msg-header {
  padding: 10px 14px;
  border-bottom: 1px solid var(--border);
  font-size: 12px;
  font-weight: 500;
  color: var(--text-2);
}
.msg-item {
  padding: 10px 14px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 10px;
}
.msg-item:last-child { border-bottom: none; }
.msg-tag {
  background: rgba(244, 47, 75, 0.1);
  color: var(--accent);
  font-size: 10px;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}
.msg-date { font-size: 11px; color: var(--text-3); }

/* Theme button */
.theme-btn {
  height: 34px;
  padding: 0 12px;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: var(--text-2);
  transition: border-color 0.15s, color 0.15s;
  white-space: nowrap;
}
.theme-btn:hover { color: var(--text-1); border-color: var(--border-2); }

/* User pill */
/* Fix dropdown z-index */
.user-dropdown .dropdown-menu {
  z-index: 9999 !important;
}
.user-dropdown .btn,
.user-dropdown .btn:focus,
.user-dropdown .btn:active {
  padding: 0;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.user-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  height: 34px;
  background: var(--bg-hover);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s;
}
.user-pill:hover { border-color: var(--accent); }
.user-avatar {
  width: 22px;
  height: 22px;
  background: var(--accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #fff;
  font-weight: 600;
}
.user-name { font-size: 12px; color: var(--text-2); }

/* ══════════════════════════════════════
   PAGE CONTENT
   ══════════════════════════════════════ */
.page-content {
  flex: 1;
  padding: 1.5rem;
  overflow-x: hidden;
}

/* ══════════════════════════════════════
   LOADING SCREEN
   ══════════════════════════════════════ */
.loading-screen {
  position: fixed;
  inset: 0;
  background: var(--bg-base);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-logo {
  width: 140px;
  height: 45px;
  background: url("~@/assets/loading_logo.png") no-repeat center;
  background-size: contain;
  animation: pulse 1.2s ease-in-out infinite;
}
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }

/* ══════════════════════════════════════
   OVERLAY (mobile)
   ══════════════════════════════════════ */
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 199;
  opacity: 0;
  transition: opacity 0.25s;
  pointer-events: none;
}

/* ══════════════════════════════════════
   RESPONSIVE
   ══════════════════════════════════════ */
@media (max-width: 768px) {

  /* Sidebar: پیش‌فرض بسته */
  .sidebar {
    transform: translateX(-100%);
  }
  .sidebar.sidebar--open {
    transform: translateX(0);
  }

  /* Close button داخل sidebar نمایش */
  .sidebar-close {
    display: flex;
  }

  /* Overlay فعال */
  .sidebar-overlay {
    display: block;
  }
  .sidebar-overlay.active {
    opacity: 1;
    pointer-events: all;
  }

  /* Hamburger نمایش */
  .hamburger {
    display: flex;
  }

  /* Main: بدون margin */
  .main {
    margin-left: 0;
  }

  .page-content {
    padding: 1rem;
  }


  .topbar {
    position: sticky;
    top: 0;
    z-index: 100;
    overflow: visible !important;  /* ← این خط مهمه */
  }

  .topbar-actions {
    position: relative;
    z-index: 9999;
  }
}

@media (max-width: 480px) {
  .theme-btn-label { display: none; }
  .user-name       { display: none; }
}

/* ══════════════════════════════════════
   GLOBAL UTILITY
   ══════════════════════════════════════ */
h1 { font-size: 22px; margin-top: 8px; color: var(--text-1); }
.breadcrumb { background-color: transparent !important; }
.cursor-pointer { cursor: pointer; }
</style>
